var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploadPicture" }, [
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.titleTxt))]),
    _c(
      "div",
      { staticClass: "list acea-row row-middle" },
      [
        _vm._l(_vm.picList, function (item, index) {
          return _c("div", { key: index, staticClass: "pictrue" }, [
            _c("img", { attrs: { src: require("@/assets/imgs/formImg.png") } }),
          ])
        }),
        _vm._m(0),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pictrue" }, [
      _c("img", { attrs: { src: require("@/assets/imgs/uploadImg.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }